import { render, staticRenderFns } from "./TaxCategoryForm.vue?vue&type=template&id=98a5cee4&"
import script from "./TaxCategoryForm.vue?vue&type=script&lang=js&"
export * from "./TaxCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports